export default __webpack_public_path__ + "static/ncase-screen-9e73d7197216bc21d58b16caaea733e3.svg";